import { StyleSheet } from "react-native";

import { fonts, radii, spacing, type ThemeColors } from "~/styles/theme";

export const makeStylesheet = (colors: ThemeColors) =>
  StyleSheet.create({
    logoPreview: {
      width: 120,
      height: 120,
      borderRadius: 8,
      backgroundColor: colors.surfaceSunken,
    },
    field: { gap: spacing.s, flexGrow: 1, flexBasis: 220, minWidth: 180 },
    fieldWide: { width: "100%", gap: spacing.s },
    multilineField: { minHeight: 84, textAlignVertical: "top" },
    formGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.m,
    },
    manualSecret: { fontFamily: fonts.mono },
    qrCode: {
      alignSelf: "center",
      width: 220,
      height: 220,
      padding: spacing.s,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.m,
      backgroundColor: colors.background,
    },
    statusGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      gap: spacing.s,
    },
    statusItem: {
      minWidth: 160,
      flexGrow: 1,
      gap: spacing.xs,
      padding: spacing.s,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.s,
      backgroundColor: colors.surfaceSunken,
    },
    newStatusPanel: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.m,
      padding: spacing.m,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.s,
      backgroundColor: colors.surfaceSunken,
    },
    statusEditor: {
      gap: spacing.m,
      paddingVertical: spacing.m,
      borderBottomWidth: 1,
      borderBottomColor: colors.hairline,
    },
    statusEditorMain: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.m,
    },
    statusNameField: { minWidth: 200, flex: 1, gap: spacing.s },
    statusStateField: { gap: spacing.s },
    statusColourField: { gap: spacing.s },
    statusColours: {
      minHeight: 38,
      flexDirection: "row",
      alignItems: "center",
      gap: spacing.xs,
    },
    statusColourButton: {
      width: 34,
      height: 34,
      alignItems: "center",
      justifyContent: "center",
      borderWidth: 2,
      borderColor: "transparent",
      borderRadius: radii.s,
    },
    statusColourButtonSelected: { borderColor: colors.heading },
    statusColourSwatch: {
      width: 24,
      height: 24,
      borderRadius: 4,
    },
    newRatePanel: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.m,
      padding: spacing.m,
      borderWidth: 1,
      borderColor: colors.hairline,
      borderRadius: radii.s,
      backgroundColor: colors.surfaceSunken,
    },
    rateEditor: {
      gap: spacing.m,
      paddingVertical: spacing.m,
      borderBottomWidth: 1,
      borderBottomColor: colors.hairline,
    },
    rateEditorGrid: {
      flexDirection: "row",
      flexWrap: "wrap",
      alignItems: "flex-end",
      gap: spacing.m,
    },
    rateNameField: { minWidth: 180, flex: 1, gap: spacing.s },
    rateField: { minWidth: 140, gap: spacing.s },
    rateScopeField: { minWidth: 210, flex: 1, gap: spacing.s },
    rateDescriptionField: { minWidth: 240, flex: 2, gap: spacing.s },
  });
